var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotificationsDefault = function SvgNotificationsDefault(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.59 15c-.06.16-.09.32-.09.5 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.18-.04-.34-.09-.5zM14 10.4c0 .91.49 1.5 1.09 1.85.41.24.91.57.91.97 0 .45-.29.77-.89.77H2.89c-.6 0-.89-.31-.89-.77 0-.4.51-.73.91-.97C3.5 11.9 4 11.3 4 10.4V7c0-2.76 2.36-5 5-5s5 2.24 5 5zm-2.76-4.277a.457.457 0 0 1 .642.019.47.47 0 0 1 .02.598L8.92 10.685l-.029.038a.78.78 0 0 1-1.083.105.3.3 0 0 1-.075-.064l-.021-.022L6.13 8.993a.537.537 0 0 1 .057-.76.55.55 0 0 1 .671-.038l1.352.817z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationsDefault);
export { ForwardRef as Icon };
export default "img/element-icons/roomlist/notifications-default.4b969b5.svg";